export default __webpack_public_path__ + "static/media/investment.91ff6d1b.webp";